module.exports = __webpack_public_path__ + "static/playground-plugin-preview-dbc16bfdfa7b81de0757bb7fad4656c1.png";